(function () {
  'use strict';

  angular
    .module('app.stores', [])

    /* @ngInject */
    .factory('StoresService', function () {
      var address;
      return {
        setAddress: function (value) {
          address = value;
        },
        getAddress: function () {
          return address;
        }
      };
    })

    .directive('stores', function () {
      return {
        restrict: 'E',
        bindToController: {
          device: '<',
          modalCtrl: '<?',
          daysModel: '@days',
          strOneTime: '@oneTime',
          strTwoTimes: '@twoTimes',
          strClosed: '@closed'
        },
        controllerAs: 'storesCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$q", "$timeout", "$filter", "AppService", "HttpService", "StoresService", "RoutesService", "GMaps", "angulargmContainer", function ($scope, $rootScope, $q, $timeout, $filter, AppService, HttpService, StoresService, RoutesService, GMaps, angulargmContainer) {
          var ctrl = this;

          var mapListerner;

          ctrl.ShowPointsList = true;

          ctrl.$onInit = function () {
            var url = '/' + RoutesService.getUrlByName('Stores');
            if (ctrl.modalCtrl) {
              ctrl.modalCtrl.loading = true;
              if (ctrl.modalCtrl.data.idProduct) {
                url += '?idProduct=' + ctrl.modalCtrl.data.idProduct;
              }
            }
            HttpService.get({
              url: url,
              cache: true
            })
              .then(function (response) {
                if (ctrl.modalCtrl) {
                  ctrl.modalCtrl.loading = false;
                }
                initStores(response.stores);
              })
              .catch(function (error) {
                console.error(error);
              });
          };

          ctrl.setShowPointsList = function (value) {
            ctrl.ShowPointsList = value;
          };
          ctrl.closePointInfo = function () {
            ctrl.pointInfos = null;
          };

          ctrl.newSearch = function (event) {
            if (ctrl.addressSearch === '') return;

            if (typeof event === 'undefined') {
              getSearchGps(ctrl.addressSearch);
            } else if (event.which === 13) {
              event.preventDefault();
              $(event.target).blur();
              getSearchGps(ctrl.addressSearch);
            }
          };

          ctrl.showStore = function (point, marker) {
            point = point || _.find(ctrl.stores, { IDCard: marker.id });
            marker = _.find(ctrl.markers, { id: point.IDCard });

            if (ctrl.storeSelected) {
              ctrl.storeSelected.selected = false;
            }

            if (point.OpeningHours[0].Date) {
              var tmp = [];
              _.each(point.OpeningHours, function (day, i) {
                var obj = {
                  day: ctrl.days[i]
                };

                if (day.IsOpen) {
                  var date, format, amStart, amEnd, pmStart, pmEnd;
                  date = new Date(day.Date1Start.replace('T', ' ').replace(/-/g, '/'));
                  format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                  amStart = $filter('date')(date, format);

                  date = new Date(day.Date1End.replace('T', ' ').replace(/-/g, '/'));
                  format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                  amEnd = $filter('date')(date, format);

                  date = new Date(day.Date2Start.replace('T', ' ').replace(/-/g, '/'));
                  if (date.getFullYear() !== 2001) {
                    format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                    pmStart = $filter('date')(date, format);

                    date = new Date(day.Date2End.replace('T', ' ').replace(/-/g, '/'));
                    format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                    pmEnd = $filter('date')(date, format);
                  }

                  obj.value = !pmStart ? $filter('format')(ctrl.strOneTime, amStart, amEnd) : $filter('format')(ctrl.strTwoTimes, amStart, amEnd, pmStart, pmEnd);
                  obj.value = day.Exception ? obj.value + ' <strong>' + day.Exception + '</strong>' : obj.value;
                } else {
                  obj.value = day.Exception ? '<strong>' + day.Exception + '</strong>' : ctrl.strClosed;
                }
                tmp.push(obj);
              });
              point.OpeningHours = tmp;
            }
            ctrl.storeSelected = point;
            ctrl.storeSelected.selected = true;

            scrollToPoint(marker.id);

            _.each(ctrl.markers, function (item) {
              item.selected = item.id === point.IDCard ? true : false;
            });

            $scope.$broadcast('gmMarkersUpdate', 'storesCtrl.markers');

            if (ctrl.device.mobile || (ctrl.modalCtrl && !ctrl.device.desktop)) {
              ctrl.pointInfos = point;
            }

            var gmapPromise = angulargmContainer.getMapPromise('map');
            gmapPromise.then(function (map) {
              setTimeout(function () {

                google.maps.event.removeListener(mapListerner);

                map.setZoom(15);
                map.panTo({ lat: marker.lat, lng: marker.lng });

                if (ctrl.device.mobile || (ctrl.modalCtrl && !ctrl.device.desktop)) {
                  var dif = ($('#map').height() / 2) - $('#pointInfos').outerHeight() - 65;
                  map.panBy(0, dif);

                  setTimeout(function () {
                    mapListerner = map.addListener('bounds_changed', function () {
                      ctrl.pointInfos = null;
                    });
                  }, 200);
                }

              });
            })
              .catch(function (error) {
                console.error(error);
              });
          };

          ctrl.getMarkerOpts = function (marker) {
            if (marker.userMarker) {
              return {
                icon: '/img/gmap/user-marker.png',
                zIndex: 1
              };
            }
            if (marker.selected) {
              return {
                title: null,
                icon: { url: '/img/gmap/store-gmap-active.png', labelOrigin: new google.maps.Point(20, 60) },
                label: { text: marker.name, fontWeight: 'bold' },
                zIndex: 3
              };
            }
            return {
              title: marker.name,
              icon: { url: '/img/gmap/store-gmap.png' },
              label: null,
              zIndex: 2
            };

          };

          // Functions
          function initStores(data) {
            ctrl.stores = _.cloneDeep(data);
            ctrl.days = ctrl.daysModel.split(',');
            ctrl.daysModel = null;
            ctrl.linkStore = '/' + RoutesService.getUrlByName('StoreDetail').split('/{storeId}')[0];

            $rootScope.$broadcast('showPageLoader', true);

            $q.all([loadVisitor(), loadGmap(), loadClusterer()])
              .then(function (results) {
                ctrl.IsLogged = results[0].IsLogged;
                ctrl.Visitor = results[0].Visitor;

                if (ctrl.IsLogged) {
                  var address = '';
                  address += ctrl.Visitor.Address !== '' ? ctrl.Visitor.Address + ' ' : '';
                  address += ctrl.Visitor.AddressLocality !== '' ? ctrl.Visitor.AddressLocality : '';
                  getSearchGps(address, ctrl.Visitor.PostCode, ctrl.Visitor.City, ctrl.Visitor.Country.Designation);
                } else {
                  showMapResults();
                }
              })
              .catch(function (error) {
                console.error(error);
              });

          }

          function loadVisitor() {
            var deferred = $q.defer();
            AppService.getParams()
              .then(function (params) {
                deferred.resolve(params);
              })
              .catch(function (error) {
                console.error(error);
              });
            return deferred.promise;
          }
          function loadGmap() {
            var deferred = $q.defer();
            GMaps.get()
              .then(function () {
                deferred.resolve('ok');
              })
              .catch(function (error) {
                console.error(error);
              });
            return deferred.promise;
          }
          function loadClusterer() {
            var deferred = $q.defer();
            GMaps.getClusterer()
              .then(function () {
                deferred.resolve('ok');
              })
              .catch(function (error) {
                console.error(error);
              });
            return deferred.promise;
          }

          function getSearchGps(address, postCode, city, country) {
            ctrl.searchLocation = null;
            var query = '';
            query += address ? address + ' ' : '';
            query += postCode ? postCode + ' ' : '';
            query += city ? city + ' ' : '';
            query += country ? country : '';

            GMaps.getGeoCode(query)
              .then(addSearchLocation)
              .catch(function (response) {
                if (response.status === 'ZERO_RESULTS') {
                  if (address && postCode) {
                    getSearchGps(null, postCode, city, country);
                  } else {
                    showMapResults();
                  }
                } else {
                  console.error(response);
                }
              });
          }

          function addSearchLocation(gps) {
            ctrl.searchLocation = {
              Coordinate: {
                Latitude: gps.Latitude,
                Longitude: gps.Longitude
              }
            };
            showMapResults();
          }

          function initMap() {
            $('#autocompleteGmap').data('init', true);
            /*
            var autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocompleteGmap'), {
              types: ['geocode'],
              componentRestrictions: { country: 'be' }
            });
            */
            var autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocompleteGmap'), {
              types: ['geocode'],
              componentRestrictions: { country: 'fr' }
            });

            google.maps.event.addListener(autocomplete, 'place_changed', function () {
              $scope.$apply(function () {
                ctrl.addressSearch = $('#autocompleteGmap').val();
                ctrl.newSearch();
              });
            });

            if (navigator.geolocation && !ctrl.geolocation) {
              ctrl.geolocation = true;
              ctrl.getGeolocation = function () {
                ctrl.loading = true;

                var defer = $q.defer();
                defer.promise.then(function (position) {
                  var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                  };
                  GMaps.getGeoCodeByGps(pos)
                    .then(function (response) {
                      ctrl.addressSearch = response.address;
                      addSearchLocation(response.gps);
                    })
                    .catch(function (error) {
                      console.error(error);
                    });
                }, function (data) {
                  ctrl.loading = false;
                });

                navigator.geolocation.getCurrentPosition(function (position) {
                  defer.resolve(position);
                }, function (err) {
                  defer.reject(err);
                });

                $timeout(function () {
                  defer.reject('timed out');
                }, 5000);

              };
            }
          }

          function showMapResults() {
            if (!$('#autocompleteGmap').data('init')) initMap();

            ctrl.markers = [];
            var bounds = new google.maps.LatLngBounds();
            if (ctrl.searchLocation) {
              ctrl.markers.push({
                id: 0,
                lat: ctrl.searchLocation.Coordinate.Latitude,
                lng: ctrl.searchLocation.Coordinate.Longitude,
                userMarker: true
              });
              bounds.extend(new google.maps.LatLng(ctrl.searchLocation.Coordinate.Latitude, ctrl.searchLocation.Coordinate.Longitude));
            }

            var minDist,
              nearPoint;
            _.each(ctrl.stores, function (point) {
              point.Distance = 0;
              if (ctrl.searchLocation) {
                point.Distance = Math.floor(google.maps.geometry.spherical.computeDistanceBetween(
                  new google.maps.LatLng(ctrl.searchLocation.Coordinate.Latitude, ctrl.searchLocation.Coordinate.Longitude),
                  new google.maps.LatLng(point.Coordinate.Latitude, point.Coordinate.Longitude)
                ));
                if (point.Distance >= 1000) {
                  var km = (point.Distance / 1000).toFixed(2);
                  km = km === Math.floor(km) ? Math.floor(km) : km;
                  km = km > 10 ? Math.floor(km) : km;
                  point.DistanceKm = String(km).replace('.', ',');
                }

                if (!minDist || point.Distance < minDist) {
                  minDist = point.Distance;
                  nearPoint = point;
                }
              }
              ctrl.markers.push({
                id: point.IDCard,
                name: point.FullName,
                lat: point.Coordinate.Latitude,
                lng: point.Coordinate.Longitude,
                selected: false
              });
              bounds.extend(new google.maps.LatLng(point.Coordinate.Latitude, point.Coordinate.Longitude));
            });

            //
            ctrl.options = {
              map: {
                center: bounds.getCenter(),
                styles: [{ 'stylers': [{ 'saturation': -100 }, { 'lightness': 50 }] }]
              }
            };
            ctrl.showMap = true;

            var gmapPromise = angulargmContainer.getMapPromise('map');
            gmapPromise.then(function (map) {
              setTimeout(function () {
                google.maps.event.trigger(map, 'resize');
                map.fitBounds(bounds);

                var markers = angulargmContainer.getMarkers('map');
                for (var i = 0; i < markers.length; i++) {
                  markers[i].setMap(null);
                }

                var options = {
                  gridSize: 50,
                  maxZoom: 15,
                  styles: [
                    {
                      width: 53,
                      height: 53,
                      url: '/img/gmap/m1.png',
                      textColor: '#ffffff'
                    },
                    {
                      width: 56,
                      height: 56,
                      url: '/img/gmap/m2.png',
                      textColor: '#ffffff'
                    },
                    {
                      width: 66,
                      height: 66,
                      url: '/img/gmap/m3.png',
                      textColor: '#ffffff'
                    },
                    {
                      width: 78,
                      height: 78,
                      url: '/img/gmap/m4.png',
                      textColor: '#ffffff'
                    },
                    {
                      width: 90,
                      height: 90,
                      url: '/img/gmap/m5.png',
                      textColor: '#ffffff'
                    }
                  ]
                };
                new MarkerClusterer(map, markers, options);

              });
            })
              .catch(function (error) {
                console.error(error);
              });

            //
            ctrl.loading = false;
            $rootScope.$broadcast('showPageLoader', false);

            var getAddress = StoresService.getAddress();
            if (getAddress) {
              $timeout(function () {
                ctrl.addressSearch = getAddress;
                ctrl.newSearch();
                StoresService.setAddress(null);
              });
            } else if (ctrl.searchLocation && nearPoint) {
              ctrl.showStore(nearPoint, null);
            }
          }

          function scrollToPoint(id) {
            var $list = $('#pointsListInner'),
              $point = $('#point_' + id);

            if ($point.length) {
              setTimeout(function () {
                $list.animate({ scrollTop: $list.scrollTop() + $point.position().top }, 350);
              }, 400);
            }
          }

        }]
      };
    });



})();
$('.shopbox .storeinline .text-store').equalHeights();

$('.shopbox').find('.storeinline .text-store .name').equalHeights();


